(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9140],{

/***/ 19140:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_SearchInput; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(36305);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(70655);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/components/context/index.ts
var context = __webpack_require__(69142);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Icon/Icon.js
var Icon = __webpack_require__(92863);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/IconButton/IconButton.js
var IconButton = __webpack_require__(17812);
// EXTERNAL MODULE: ./src/utils/parse-utils.js
var parse_utils = __webpack_require__(80865);
// EXTERNAL MODULE: ./node_modules/ramda/es/index.js + 190 modules
var es = __webpack_require__(9280);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/SearchInput/SearchInput.module.scss
var SearchInput_module = __webpack_require__(27378);
;// CONCATENATED MODULE: ./src/components/SearchInput/SearchInput.js














/**
 * @params  {*}
 * defaultKeyword: default search input value
 * placeholder: search input placeholder
 * suggestion: show suggestion list
 * searchHistory: post & delete history policy
 * autoComplete: show auto complete list
 * AutoCompleteList: AutoCompleteList Component
 * SuggestionList: this component will includes [...historyList,...trendingList]
 * handleSearch(searchKeyword): handle search action
 * postSearchHistory: post search history
 * deleteSearchHistory: delete search history
 * getAutoCompleteList: autoComplete Resource,
 * getSearchHistory: searchHistory Resource,
 * getTrendingList: trending Resource,
 */ var SearchInput = function(param) {
    var forwardedRef = param.forwardedRef, _param_defaultKeyword = param.defaultKeyword, defaultKeyword = _param_defaultKeyword === void 0 ? "" : _param_defaultKeyword, _param_placeholder = param.placeholder, placeholder = _param_placeholder === void 0 ? "" : _param_placeholder, _param_suggestion = param.suggestion, suggestion = _param_suggestion === void 0 ? true : _param_suggestion, _param_searchHistory = param.searchHistory, searchHistory = _param_searchHistory === void 0 ? true : _param_searchHistory, _param_autoComplete = param.autoComplete, autoComplete = _param_autoComplete === void 0 ? true : _param_autoComplete, _param_AutoCompleteList = param.AutoCompleteList, AutoCompleteList = _param_AutoCompleteList === void 0 ? null : _param_AutoCompleteList, _param_SuggestionList = param.SuggestionList, SuggestionList = _param_SuggestionList === void 0 ? null : _param_SuggestionList, maxInputLength = param.maxInputLength, _param_handleSearch = param.handleSearch, handleSearch = _param_handleSearch === void 0 ? function() {
    // This is intentional
    } : _param_handleSearch, _param_handleCleanSearch = param.handleCleanSearch, handleCleanSearch = _param_handleCleanSearch === void 0 ? function() {
    // This is intentional
    } : _param_handleCleanSearch, _param_postSearchHistory = param.postSearchHistory, postSearchHistory = _param_postSearchHistory === void 0 ? /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        return (0,tslib_es6.__generator)(this, function(_state) {
            return [
                2
            ];
        });
    // This is intentional
    }) : _param_postSearchHistory, _param_deleteSearchHistory = param.deleteSearchHistory, deleteSearchHistory = _param_deleteSearchHistory === void 0 ? function() {
    // This is intentional
    } : _param_deleteSearchHistory, _param_getAutoCompleteList = param.getAutoCompleteList, getAutoCompleteList = _param_getAutoCompleteList === void 0 ? /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        return (0,tslib_es6.__generator)(this, function(_state) {
            return [
                2
            ];
        });
    // This is intentional
    }) : _param_getAutoCompleteList, _param_getSearchHistory = param.getSearchHistory, getSearchHistory = _param_getSearchHistory === void 0 ? /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        return (0,tslib_es6.__generator)(this, function(_state) {
            return [
                2
            ];
        });
    // This is intentional
    }) : _param_getSearchHistory, _param_getTrendingList = param.getTrendingList, getTrendingList = _param_getTrendingList === void 0 ? /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        return (0,tslib_es6.__generator)(this, function(_state) {
            return [
                2
            ];
        });
    // This is intentional
    }) : _param_getTrendingList;
    var inputRef = /*#__PURE__*/ (0,react.createRef)();
    var _useContext = (0,react.useContext)(context/* default */.ZP), rootStatus = _useContext.loginStatus;
    var userLanguage = (rootStatus || {}).userLanguage;
    var _useState = (0,_sliced_to_array/* default */.Z)((0,react.useState)(0), 2), currentKeyCode = _useState[0], setCurrentKeyCode = _useState[1];
    var _useState1 = (0,_sliced_to_array/* default */.Z)((0,react.useState)(-1), 2), suggestionIndex = _useState1[0], setSuggestionIndex = _useState1[1];
    var _useState2 = (0,_sliced_to_array/* default */.Z)((0,react.useState)([]), 2), suggestionArray = _useState2[0], setSuggestionArray = _useState2[1];
    var _useState3 = (0,_sliced_to_array/* default */.Z)((0,react.useState)([]), 2), autoCompleteList = _useState3[0], setAutoCompleteList = _useState3[1];
    var _useState4 = (0,_sliced_to_array/* default */.Z)((0,react.useState)(false), 2), showSuggestion = _useState4[0], setShowSuggestion = _useState4[1];
    var _useState5 = (0,_sliced_to_array/* default */.Z)((0,react.useState)(false), 2), showKeyword = _useState5[0], setShowKeyword = _useState5[1];
    var _useState6 = (0,_sliced_to_array/* default */.Z)((0,react.useState)(false), 2), getTrendingDone = _useState6[0], setGetTrendingDone = _useState6[1];
    var _useState7 = (0,_sliced_to_array/* default */.Z)((0,react.useState)(false), 2), isFocus = _useState7[0], setIsFocus = _useState7[1];
    var _useState8 = (0,_sliced_to_array/* default */.Z)((0,react.useState)(false), 2), isKeywordInput = _useState8[0], setIsKeywordInput = _useState8[1];
    var _useState9 = (0,_sliced_to_array/* default */.Z)((0,react.useState)(false), 2), showCleanSearchButton = _useState9[0], setShowCleanSearchButton = _useState9[1];
    var _useState10 = (0,_sliced_to_array/* default */.Z)((0,react.useState)(0), 2), autoCompleteTotalCount = _useState10[0], setAutoCompleteTotalCount = _useState10[1];
    var selectedArray = isKeywordInput ? autoCompleteList : suggestionArray;
    var showSuggestionList = showSuggestion && !isKeywordInput && suggestion;
    var showAutoCompleteList = isFocus && isKeywordInput && showKeyword && autoComplete;
    var isClose = function(n) {
        return n.classList && n.classList[0] === "close";
    };
    var plusSuggestionIndex = function(index) {
        if (index === selectedArray.length - 1) {
            return 0;
        }
        return index + 1;
    };
    var reduceSuggestionIndex = function(index) {
        if (index === 0) {
            return selectedArray.length - 1;
        }
        return index - 1;
    };
    var getSearchKeyword = function(inputComponentRef) {
        var _inputComponentRef_current, _inputComponentRef_current_value;
        return (inputComponentRef === null || inputComponentRef === void 0 ? void 0 : (_inputComponentRef_current = inputComponentRef.current) === null || _inputComponentRef_current === void 0 ? void 0 : (_inputComponentRef_current_value = _inputComponentRef_current.value) === null || _inputComponentRef_current_value === void 0 ? void 0 : _inputComponentRef_current_value.trim()) || "";
    };
    var recordSearchHistory = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!((rootStatus === null || rootStatus === void 0 ? void 0 : rootStatus.token) && searchHistory)) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            postSearchHistory(getSearchKeyword(inputRef))
                        ];
                    case 1:
                        _state.sent();
                        _state.label = 2;
                    case 2:
                        return [
                            2
                        ];
                }
            });
        });
        return function recordSearchHistory() {
            return _ref.apply(this, arguments);
        };
    }();
    var searchAction = function() {
        var index = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
        setShowSuggestion(false);
        setShowKeyword(false);
        if (searchHistory) {
            recordSearchHistory();
        }
        if (inputRef.current.value) {
            inputRef.current.value = inputRef.current.value.trim();
        }
        handleSearch(selectedArray[index] || selectedArray[suggestionIndex] || getSearchKeyword(inputRef));
    };
    var getAutoCompleteListResource = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var searchKeyword, _ref, _ref_data, data, error, totalCount, temp, error1;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        searchKeyword = getSearchKeyword(inputRef);
                        if (!searchKeyword) return [
                            3,
                            4
                        ];
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            getAutoCompleteList(searchKeyword)
                        ];
                    case 2:
                        _ref = _state.sent(), _ref_data = _ref.data, data = _ref_data === void 0 ? [] : _ref_data, error = _ref.error, totalCount = _ref.totalCount;
                        setAutoCompleteTotalCount(totalCount);
                        if (error) {
                            throw error;
                        } else {
                            temp = [];
                            data.forEach(function(item) {
                                temp.push({
                                    text: item,
                                    type: "keyword"
                                });
                            });
                            setAutoCompleteList((0,_to_consumable_array/* default */.Z)(temp));
                        }
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error1 = _state.sent();
                        console.error("getAutoCompleteListResource", error1);
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function getAutoCompleteListResource() {
            return _ref.apply(this, arguments);
        };
    }();
    var getSearchSource = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var histories, _ref, searchHistoryData, searchHistoryError, _ref1, tmp, trendingList, trendingListError, temp, flag, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            5,
                            ,
                            6
                        ]);
                        histories = [];
                        if (!((rootStatus === null || rootStatus === void 0 ? void 0 : rootStatus.token) && searchHistory)) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            getSearchHistory()
                        ];
                    case 1:
                        _ref = _state.sent(), searchHistoryData = _ref.data, searchHistoryError = _ref.error;
                        if (searchHistoryError) {
                            throw searchHistoryError;
                        }
                        if (searchHistoryData) {
                            searchHistoryData.forEach(function(item) {
                                histories.push({
                                    text: item,
                                    type: "history"
                                });
                            });
                        }
                        _state.label = 2;
                    case 2:
                        if (!suggestion) return [
                            3,
                            4
                        ];
                        return [
                            4,
                            getTrendingList({
                                language: userLanguage
                            })
                        ];
                    case 3:
                        _ref1 = _state.sent(), tmp = _ref1.data, trendingList = tmp === void 0 ? [] : tmp, trendingListError = _ref1.error;
                        if (trendingListError) {
                            throw trendingListError;
                        }
                        temp = [];
                        flag = 0;
                        trendingList.forEach(function(item) {
                            if (flag <= 1) {
                                temp.push({
                                    text: item,
                                    type: "trending"
                                });
                                flag += 1;
                            }
                        });
                        setSuggestionArray((0,_to_consumable_array/* default */.Z)(histories).concat((0,_to_consumable_array/* default */.Z)(temp)));
                        _state.label = 4;
                    case 4:
                        return [
                            3,
                            6
                        ];
                    case 5:
                        error = _state.sent();
                        console.error("getSearchSource", error);
                        return [
                            3,
                            6
                        ];
                    case 6:
                        return [
                            2
                        ];
                }
            });
        });
        return function getSearchSource() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleKeyUp = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(event) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                setCurrentKeyCode(event.keyCode);
                if (event.keyCode === 40) {
                    // keypress: down
                    setShowSuggestion(true);
                    setSuggestionIndex(plusSuggestionIndex(suggestionIndex));
                } else if (event.keyCode === 38) {
                    // keypress: up
                    setShowSuggestion(true);
                    setSuggestionIndex(reduceSuggestionIndex(suggestionIndex));
                } else if (event.keyCode === 13) {
                    event.preventDefault();
                } else {
                    setShowSuggestion(true);
                }
                return [
                    2
                ];
            });
        });
        return function handleKeyUp(event) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleBlur = function() {
        setSuggestionIndex(-1);
    };
    var handleFocus = function() {
        setShowSuggestion(true);
        setIsFocus(true);
    };
    var handleKeywordChange = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(event) {
            var value;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        value = event.target.value;
                        if (!isKeywordInput) {
                            setSuggestionIndex(-1);
                        }
                        setIsKeywordInput(value.trim());
                        setShowKeyword(value.trim());
                        if (!autoComplete) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            getAutoCompleteListResource()
                        ];
                    case 1:
                        _state.sent();
                        _state.label = 2;
                    case 2:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleKeywordChange(event) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleMouseOver = function(index) {
        setSuggestionIndex(index);
    };
    var focusTarget = function(index) {
        var text = selectedArray[index].text;
        var name = text.name;
        inputRef.current.value = name || typeof text !== "string" && (0,parse_utils/* getUserName */.vW)(text) || text;
    };
    var selectTarget = function(index) {
        var event = window.event;
        // The path property of Event objects is non-standard. The standard equivalent is composedPath, which is a method.
        var path = event.path || event.composedPath && event.composedPath();
        if ((0,es/* filter */.hXT)(isClose, path).length === 0) {
            focusTarget(index);
            searchAction(index);
            setIsFocus(false);
        }
    };
    var controlSuggestion = function(evt) {
        var event = evt || window.event;
        if (event) {
            var _event_target;
            // The path property of Event objects is non-standard. The standard equivalent is composedPath, which is a method.
            var path = event.path || event.composedPath && event.composedPath();
            var isSearchInput = typeof ((_event_target = event.target) === null || _event_target === void 0 ? void 0 : _event_target.className) === "string" && event.target.className.indexOf("searchInput") >= 0;
            setShowSuggestion(isSearchInput || (0,es/* filter */.hXT)(isClose, path).length !== 0);
            setShowKeyword(isSearchInput);
        }
    };
    (0,react.useEffect)(function() {
        var _inputRef_current;
        if (suggestionIndex >= 0 && suggestionIndex <= selectedArray.length - 1 && (currentKeyCode === 38 || currentKeyCode === 40)) {
            focusTarget(suggestionIndex);
        }
        setShowCleanSearchButton((_inputRef_current = inputRef.current) === null || _inputRef_current === void 0 ? void 0 : _inputRef_current.value);
    }, [
        isKeywordInput,
        suggestionArray,
        autoCompleteList,
        suggestionIndex,
        inputRef,
        currentKeyCode
    ]);
    (0,react.useEffect)(function() {
        window.addEventListener("click", controlSuggestion);
        return function() {
            window.removeEventListener("click", controlSuggestion);
        };
    }, [
        showSuggestion
    ]);
    (0,react.useEffect)(function() {
        if (showKeyword && !getTrendingDone) {
            setGetTrendingDone(true);
            if (autoComplete) getSearchSource();
        }
    }, [
        showKeyword,
        getTrendingDone
    ]);
    (0,react.useEffect)(function() {
        if (autoComplete) getSearchSource();
    }, []);
    var cleanSearchHandler = function() {
        inputRef.current.value = "";
        handleCleanSearch();
        searchAction();
    };
    var formSubmit = function(event) {
        event.preventDefault();
        searchAction();
    };
    (0,react.useImperativeHandle)(forwardedRef, function() {
        return {
            search: function() {
                return searchAction();
            }
        };
    });
    var renderSearchResultList = function(isShowSuggestionList, isShowAutoCompleteList) {
        if (isShowSuggestionList) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(SuggestionList, {
                searchHistory: searchHistory,
                suggestionArray: suggestionArray,
                handleMouseOver: handleMouseOver,
                selectTarget: selectTarget,
                suggestionIndex: suggestionIndex,
                deleteSearchHistory: deleteSearchHistory,
                setSuggestionArray: setSuggestionArray
            });
        }
        if (isShowAutoCompleteList) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(AutoCompleteList, {
                autoCompleteArray: autoCompleteList,
                handleMouseOver: handleMouseOver,
                selectTarget: selectTarget,
                suggestionIndex: suggestionIndex,
                inputRef: inputRef,
                autoCompleteTotalCount: autoCompleteTotalCount,
                setAutoCompleteList: setAutoCompleteList
            });
        }
        return null;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: SearchInput_module.searchInputWrapper,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                autoComplete: "off",
                onSubmit: formSubmit,
                className: SearchInput_module.searchForm,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                        onClick: searchAction,
                        className: SearchInput_module.searchIcon,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                            children: "search"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        id: "searchInput",
                        ref: inputRef,
                        onKeyUp: handleKeyUp,
                        onBlur: handleBlur,
                        onFocus: handleFocus,
                        onChange: handleKeywordChange,
                        className: SearchInput_module.searchInput,
                        defaultValue: defaultKeyword,
                        placeholder: placeholder,
                        autoComplete: "off",
                        role: "searchInput",
                        maxLength: maxInputLength
                    }),
                    showCleanSearchButton && /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                        className: SearchInput_module.icon_close,
                        onClick: cleanSearchHandler,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                            children: "close"
                        })
                    })
                ]
            }),
            renderSearchResultList(showSuggestionList, showAutoCompleteList)
        ]
    });
};
var SearchInputForwarded = /*#__PURE__*/ (0,react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchInput, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        forwardedRef: ref
    }));
});
SearchInputForwarded.displayName = "SearchInput";
/* harmony default export */ var SearchInput_SearchInput = (SearchInputForwarded);

;// CONCATENATED MODULE: ./src/components/SearchInput/index.js

/* harmony default export */ var components_SearchInput = (SearchInput_SearchInput);


/***/ }),

/***/ 80865:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "JA": function() { return /* binding */ getEmailUserName; },
/* harmony export */   "Kh": function() { return /* binding */ renderArrowDirectionIcons; },
/* harmony export */   "LR": function() { return /* binding */ mailNotExistedInfoMessage; },
/* harmony export */   "M_": function() { return /* binding */ passInputType; },
/* harmony export */   "g4": function() { return /* binding */ getAvatarName; },
/* harmony export */   "vW": function() { return /* binding */ getUserName; }
/* harmony export */ });
/* harmony import */ var ramda__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9280);

var getUserName = function() {
    var userInfo = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    if (userInfo === null) {
        return "";
    }
    if (userInfo.name) {
        return userInfo.name;
    }
    if (userInfo.firstName && userInfo.lastName) {
        if (userInfo.firstName === userInfo.lastName) {
            return "".concat(userInfo.firstName);
        }
        return "".concat(userInfo.firstName, " ").concat(userInfo.lastName);
    }
    if (userInfo.firstName) {
        return userInfo.firstName;
    }
    if (userInfo.lastName) {
        return userInfo.lastName;
    }
    return "";
};
var getAvatarName = function() {
    var userInfo = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return getUserName(userInfo).slice(0, 1);
};
var getEmailUserName = function() {
    var userInfo = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    if (userInfo.email) {
        return userInfo.email.split("@")[0];
    }
    return "";
};
var passInputType = function(openEyes) {
    return openEyes ? "text" : "password";
};
var renderArrowDirectionIcons = function(type) {
    if (type > 0) {
        return "North";
    }
    if (type === 0) {
        return "ArrowRight";
    }
    return "South";
};
var mailNotExistedInfoMessage = function(addCsvUploadData, mailNotExistedInfo) {
    var result = "";
    mailNotExistedInfo.details.forEach(function(item) {
        var csvIndex = (0,ramda__WEBPACK_IMPORTED_MODULE_0__/* .findIndex */ .cxD)((0,ramda__WEBPACK_IMPORTED_MODULE_0__/* .propEq */ .OH4)("email", item))(addCsvUploadData) + 2;
        if (result === "") {
            result += "A".concat(csvIndex);
        } else {
            result += ", A".concat(csvIndex);
        }
    });
    return result;
};


/***/ }),

/***/ 27378:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"blue11":"#00aced","blue900":"#395798","blue800":"#126bc4","blue700":"#0083e5","blue600":"#0099ef","blue500":"#00adef","blue400":"#23c2ff","blue300":"#56d0ff","blue200":"#89deff","blue100":"#abe8ff","blue50":"#caeafe","green900":"#60a127","green800":"#72ae37","green700":"#7cb540","green600":"#87bd4a","green500":"#8fc351","green400":"#a0cc6b","green300":"#b1d585","green200":"#c7e1a8","green100":"#ddedcb","green50":"#f2f8ea","purple900":"#5a4483","purple800":"#6d5793","purple700":"#77619c","purple600":"#826ca6","purple500":"#8a74ad","purple400":"#9c89b9","purple300":"#ad9ec6","purple200":"#c5bad6","purple100":"#dcd5e6","purple50":"#f1eef5","yellow900":"#ffa102","yellow800":"#ffae04","yellow700":"#ffb505","yellow600":"#ffbd06","yellow500":"#ffc307","yellow400":"#ffcc2c","yellow300":"#ffd551","yellow200":"#ffe183","yellow100":"#ffedb5","yellow50":"#fff8e1","red900":"#db3631","red800":"#e14842","red700":"#e4524c","red600":"#e75c56","red500":"#ea645e","red400":"#ed7b76","red300":"#f0938e","red200":"#f5b2af","red100":"#f9d1cf","red50":"#fcecec","gray01":"#fafafa","gray02":"#efefef","gray900":"#3f3f3f","gray800":"#4d4c4c","gray700":"#595757","gray600":"#666565","gray500":"#727171","gray400":"#878686","gray300":"#9fa0a0","gray200":"#b5b5b6","gray100":"#c9caca","gray50":"#e8e8e8","gray30":"#f1f1f1","gray15":"#f9f9f9","btnLogin":"SearchInput_btnLogin__MmFcL","iconBox":"SearchInput_iconBox__Iv788","right":"SearchInput_right__7hR6G","left":"SearchInput_left__qTaVb","pageFabButton":"SearchInput_pageFabButton__sJ58t","loading":"SearchInput_loading__1Ig4O","buttonText":"SearchInput_buttonText__RbKaO","backToTop":"SearchInput_backToTop__F7K_M","rwdButton":"SearchInput_rwdButton__yBhQf","largeButton":"SearchInput_largeButton__M3O7r","smallButton":"SearchInput_smallButton__GPv3m","searchInputWrapper":"SearchInput_searchInputWrapper__cAkb_","suggestion":"SearchInput_suggestion__dicji","suggestionList":"SearchInput_suggestionList__Gq2L7","categoryTitle":"SearchInput_categoryTitle__Youjj","trendingHover":"SearchInput_trendingHover__ZjwnR","focus":"SearchInput_focus__sYqtl","close":"SearchInput_close__jc1QD","history":"SearchInput_history__WbA7B","trending":"SearchInput_trending__ihQfm","text":"SearchInput_text___FhP3","searchForm":"SearchInput_searchForm__cNoHZ","searchInput":"SearchInput_searchInput__6MZeV","searchIcon":"SearchInput_searchIcon__2jguf","icon_close":"SearchInput_icon_close___gnXY"};

/***/ })

}]);